import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    min_price: null,
    max_price: null,
    orderingName: '', //for user
    ordering: '', //for db
    trigger: true,
    searchValue: '',
    package_names: '',
}

const filtersForCleanerSlice = createSlice({
    name: 'filtersForCleanerSlice',
    initialState,
    reducers: {
        setMinPrice(state, action) {
            state.min_price = action.payload;
        },
        setMaxPrice(state, action) {
            state.max_price = action.payload;
        },
        setOrdering(state, action) {
            const {name, ordering} = action.payload;
            state.orderingName = name;
            state.ordering = ordering;
        },
        setTrigger: (state, action) => {
            state.trigger = !state.trigger;
        },
        setSearchValue: (state, action) => {
            state.searchValue = action.payload;
        },
        clearFilters: (state, action) => {
            state.min_price = null;
            state.max_price = null;
            state.orderingName = '';
            state.ordering = '';
            state.package_names = null;
        },
        setPackageNames: (state, action) => {
            state.package_names = action.payload;
        }
    },
});

const {actions, reducer: filtersForCleanerReducer} = filtersForCleanerSlice;

const filtersForCleanerActions = {
    ...actions,
}

export {
    filtersForCleanerActions,
    filtersForCleanerReducer,
}
